// extracted by mini-css-extract-plugin
export default {"inhecoScilaLiveDoorStatus":"inhecoScilaLiveDoorStatus-YU3pX","doorStatusOpened":"doorStatusOpened-LLT1Q","doorStatusClosed":"doorStatusClosed-NFNL6"};